export default __webpack_public_path__ + "static/media/eye-some.9be9fafb.png";